import axios from "axios";
import React, { useEffect, useState } from "react";

import { useShopify } from "@app/scripts/react-hooks/shopify";
import { ProductCarousel } from "@app/scripts/react-product-carousel/components/ProductCarousel";

import type { NormalisedProduct } from "@app/scripts/types";

type Props = {
  productId?: string | number | null;
  columnsDesktop: number | "auto";
  columnsMobile: number | "auto";
  disabledMobile: boolean;
  disabledDesktop: boolean;
  quickAddStyle?: "default" | "pin" | "plp";
  spaceBetween?: number;
  productsToShow: number;
};

export const ProductRecommendations: React.FC<Props> = ({
  productId,
  columnsDesktop,
  columnsMobile,
  disabledDesktop,
  disabledMobile,
  quickAddStyle = "pin",
  spaceBetween = 8,
  productsToShow,
}) => {
  const { normaliseProduct } = useShopify();
  const [products, setProducts] = useState<NormalisedProduct[]>([]);

  useEffect(() => {
    const q = async () => {
      if (!productId) return;

      const res = await axios.get(`/recommendations/products.json?product_id=${productId}&limit=${productsToShow}`);

      if (res?.data?.products?.length) {
        setProducts(res?.data?.products?.map((p) => normaliseProduct(p)));
      }
    };
    q();
  }, []);

  return (
    <ProductCarousel
      originalClass="product-grid item-carousel columns-desktop__4"
      columnsDesktop={columnsDesktop}
      columnsMobile={columnsMobile}
      disabledDesktop={disabledDesktop}
      products={products}
      disabledMobile={disabledMobile}
      scrollbarMobile={false}
      transparentBtns={false}
      hasQuickAddDrawer={true}
      quickAddStyle={quickAddStyle}
      spaceBetween={spaceBetween}
      showArrows={false}
      showScrollbar={false}
    />
  );
};
